import {
  DrugEntity,
} from './drugEntity';
import { DrugContent } from './valueObjects/drugContent';
import { MeasureDateTime } from './valueObjects/measureDateTime';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { ParentId } from './valueObjects/parentId';

import type {
  DrugPropsPub,
  DrugPropsPvt,
} from './drugEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { DrugJsonPub, DrugJsonPvt } from '@/types/domain/drug/entities/drugEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class DrugFactory extends FactoryPub<
  DrugEntity,
  DrugPropsPvt,
  DrugJsonPvt,
  DrugPropsPub,
  DrugJsonPub
> {
  comparePub = (
    a: EntityDataPubType<DrugJsonPvt, DrugJsonPub>,
    b: EntityDataPubType<DrugJsonPvt, DrugJsonPub>,
  ) => {
    const da = new Date(a.data.measureDateTime);
    const db = new Date(b.data.measureDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: DrugPropsPvt,
    propsPub: EntityPubNotNullType<DrugPropsPub>,
  ): DrugEntity {
    return new DrugEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<DrugJsonPvt, DrugJsonPub>,
  ): DrugEntity {
    return this.create({
      measureDateTime: MeasureDateTime.create(new Date(props.data.measureDateTime)),
      measurerId: MeasurerId.create(props.data.measurerId),
      measurerType: MeasurerType.create(props.data.measurerType),
      parentId: ParentId.create(props.data.parentId),
      childId: ParentId.create(props.data.childId),
      drugContent: DrugContent.create(props.data.drugContent),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
